'use client';

import { buildReturnToWebsiteUrl } from '@/helpers/return-to-website';
import { VpLink } from '@vtmn-play/react';
import { useTranslations } from 'next-intl';
import { useDidomi } from '@/providers/didomi.provider';
import { usePathname } from 'next/navigation';
import { RoutesEnum } from '@/enums/routes.enum';

import './Footer.scss';

interface FooterProps {
  country: string;
  privacyPolicyUrl?: string;
}

const Footer = ({ country, privacyPolicyUrl }: FooterProps) => {
  const { isReady, showPreferences } = useDidomi();
  const t = useTranslations('Widget.component.footer');
  const pathname = usePathname();

  const hideFooter = pathname?.includes(RoutesEnum.CONFIRM);

  if (hideFooter) {
    return null;
  }

  return (
    <footer className='standalone-footer footer flex-col sm:flex-row'>
      {isReady && (
        <VpLink href='#' role='button' size='small' onClick={showPreferences}>
          {t('links.cookieSettings')}
        </VpLink>
      )}
      {privacyPolicyUrl && (
        <VpLink
          href={privacyPolicyUrl}
          rel='noopener noreferrer'
          size='small'
          target='_blank'
        >
          {t('links.cookiePolicy')}
        </VpLink>
      )}
      <div className='flex align-center gap-2 sm:ms-auto mbs-4 sm:mbs-auto'>
        <VpLink
          href={buildReturnToWebsiteUrl(country)}
          rel='noopener noreferrer'
          size='small'
          target='_blank'
        >
          ©2026 Decathlon
        </VpLink>
      </div>
    </footer>
  );
};

export default Footer;
